import PropTypes from "prop-types";

/**
 * Success state component for displaying success confirmations
 * Shows checkmark icon with title and message
 *
 * @component
 * @param {Object} props
 * @param {string} [props.title="Success!"] - Success title
 * @param {string} [props.message=""] - Success message
 * @param {string} [props.note=""] - Optional additional note
 * @param {string} [props.className=""] - Additional CSS classes
 * @param {React.ReactNode} [props.children] - Optional children to render below message
 */
const SuccessState = ({ title = "Success!", message = "", note = "", className = "", children }) => {
  return (
    <div className={`success-state ${className}`}>
      <div className="success-content">
        <div className="success-icon">
          <div
            className="checkmark-icon"
            style={{
              width: "64px",
              height: "64px",
              fontSize: "48px",
              color: "#28a745",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✓
          </div>
        </div>
        <h3>{title}</h3>
        {message && <p className="success-message">{message}</p>}
        {note && <p className="success-note">{note}</p>}
        {children}
      </div>
    </div>
  );
};

SuccessState.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  note: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default SuccessState;
